var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86489 4.86481C7.45764 2.2721 11.0423 0.666687 15.0001 0.666687C18.9578 0.666687 22.5425 2.2721 25.1353 4.86482C27.728 7.45758 29.3334 11.0423 29.3334 15C29.3334 18.9578 27.728 22.5425 25.1353 25.1352C22.5425 27.7279 18.9578 29.3334 15.0001 29.3334C11.0423 29.3334 7.45764 27.7279 4.86489 25.1352C2.27217 22.5425 0.666748 18.9578 0.666748 15C0.666748 11.0423 2.27217 7.45757 4.86489 4.86481ZM15.0001 2.66669C11.5941 2.66669 8.51212 4.04605 6.27909 6.27904C4.0461 8.51207 2.66675 11.594 2.66675 15C2.66675 18.406 4.04611 21.488 6.2791 23.721C8.51212 25.954 11.5941 27.3334 15.0001 27.3334C18.4061 27.3334 21.488 25.954 23.721 23.721C25.954 21.488 27.3334 18.406 27.3334 15C27.3334 11.594 25.954 8.51206 23.721 6.27904C21.488 4.04605 18.4061 2.66669 15.0001 2.66669Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 11.4166C10.0001 8.65519 12.2387 6.41661 15.0001 6.41661C17.7615 6.41661 20.0001 8.65519 20.0001 11.4166C20.0001 13.8356 18.2823 15.8533 16.0001 16.3166V18.0833C16.0001 18.6356 15.5524 19.0833 15.0001 19.0833C14.4478 19.0833 14.0001 18.6356 14.0001 18.0833V15.4166C14.0001 14.8643 14.4478 14.4166 15.0001 14.4166C16.6569 14.4166 18.0001 13.0735 18.0001 11.4166C18.0001 9.75976 16.6569 8.41661 15.0001 8.41661C13.3432 8.41661 12.0001 9.75976 12.0001 11.4166C12.0001 11.9689 11.5524 12.4166 11.0001 12.4166C10.4478 12.4166 10.0001 11.9689 10.0001 11.4166Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0001 24.0833C15.9205 24.0833 16.6667 23.3371 16.6667 22.4166C16.6667 21.4961 15.9205 20.7499 15.0001 20.7499C14.0796 20.7499 13.3334 21.4961 13.3334 22.4166C13.3334 23.3371 14.0796 24.0833 15.0001 24.0833Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.019c56a9.svg";
export { ForwardRef as ReactComponent };